import { WebSocketMessage } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';
import { useTonStore } from '@/store/useTonStore.ts';

export const handleTonChallengeUnlocked = (ctxData: WebSocketMessage) => {
  if (ctxData.ton_challenge_unlocked_event?.challenge) {
    const { replaceChallengeFromWS } = useTonStore.getState();

    replaceChallengeFromWS(ctxData.ton_challenge_unlocked_event?.challenge);
  }
};
